import {registerRoute} from '@/router'
import AccountPickerDebug from '@/account-picker/AccountPickerDebug.vue'

registerRoute({
    componentName: 'AccountPickerDebug',
    component: AccountPickerDebug,
    meta: {requiresOrg: true}
})